<div class="box p-0">
  <header class="card-header">
    <p class="card-header-title" *ngIf="header">
      {{ header }}
    </p>
  </header>
  <!-- Oude contactlijst had hier een plaatje in plaats van de google maps iframe -->
  <figure *ngIf="image" class="image">
    <img
      style="border-top-left-radius: 0.25rem; border-top-right-radius: 0.25rem; object-fit: cover;" 
      alt="Card Image"
      src="{{image}}"
    />
  </figure>

  <div class="card-content">
    <ng-content></ng-content>
  </div>
  <footer class="card-footer" *ngIf="footer">
    <a [routerLink]="footer" class="card-footer-item">Meer</a>
  </footer>
</div>
